'use client';

import { useAccessibility } from '@/context/AccessibilityProvider';
import { MotionConfig } from 'framer-motion';

export default function A11yMotionConfig({ children }: { children: React.ReactNode }) {
  const { reducedMotion } = useAccessibility();
  return <MotionConfig reducedMotion={reducedMotion ? 'always' : 'user'}>{children}</MotionConfig>;
}
